import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Script from 'next/script';
export const CookieConsentScripts = () => {
    return (_jsxs(_Fragment, { children: [_jsx(Script, { src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js", type: "text/javascript", "data-domain-script": dataDomainScript, strategy: "afterInteractive" }), _jsx(Script, { id: "optanon-wrapper", type: "text/javascript", strategy: "afterInteractive", children: 'function OptanonWrapper() {}' })] }));
};
// on non-prod, we need to append "-test", else it would be tied to the cronos.org domain
// see https://my.onetrust.com/s/article/UUID-7478d3b4-18eb-3ac0-a6fd-fb7ebff9f8dc?language=en_US#UUID-7478d3b4-18eb-3ac0-a6fd-fb7ebff9f8dc_section-idm459157160865603155449277971
const dataDomainScript = process.env.APP_ENV === 'prod'
    ? '66fc3c7f-223e-474e-9210-c617c1a7459d'
    : '66fc3c7f-223e-474e-9210-c617c1a7459d-test';
